/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { useTracker } from '../../../context/hooks';
import { createAttachedContent } from '../data/attachedContent/thunks';
import { selectSelectedCluster } from '../data/clusters/slice';
import { selectContentId } from '../data/content/slice';
import { selectSelectedClusterId, selectSelectedSubtopicId } from '../data/topicEditor/slice';
import { useDispatch, useSelector } from '../store';
import { jsx as _jsx } from "react/jsx-runtime";
export const AttachButton = () => {
  const {
    track
  } = useTracker();
  const dispatch = useDispatch();
  const contentId = useSelector(selectContentId);
  const selectedClusterId = useSelector(selectSelectedClusterId);
  const selectedSubtopicId = useSelector(selectSelectedSubtopicId);
  const cluster = useSelector(selectSelectedCluster);
  const canAttachToCluster = !!cluster && !cluster.coreTopic.hasAttachedContent;
  const canAttach = canAttachToCluster || !!selectedSubtopicId;
  const handleClick = () => {
    track('clickedAttachTopic');
    const topicId = selectedSubtopicId || !!cluster && cluster.coreTopic.id;
    if (selectedClusterId && topicId && contentId) {
      dispatch(createAttachedContent(contentId, selectedClusterId, topicId));
    }
  };
  return /*#__PURE__*/_jsx(UILoadingButton, {
    "data-test-id": "topic-editor-attach-button",
    type: "submit",
    use: "primary",
    duration: 1000,
    className: "m-top-6",
    disabled: !canAttach,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.actions.submit"
    })
  });
};